import { useContext, createContext } from 'react';
import { Colors } from '@app/theme';

export const NavbarColorContext = createContext<Colors>('red');
export const useNavbarColor = () => useContext(NavbarColorContext);
